import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { SettingsService } from '../../../shared/settings/settings.service';
import { LDWDocument } from '../../../shared/models/LDWDocument';
import { SelectionArguments } from '../../../shared/models/selection-arguments';
import { DocumentToolbarMode } from '../../../shared/enums/document-toolbar-mode';

@Component({
    selector: 'ldw-document-toolbar',
    templateUrl: './document-toolbar.component.html',
    styleUrls: ['./document-toolbar.component.css'],
    standalone: false
})
export class DocumentToolbarComponent {
  private settingsService = inject(SettingsService);

  @Input() document: LDWDocument | undefined = undefined;
  @Input() isReadOnly = true;
  @Input() allowStatusChange = false;
  @Input() showBookmark = false;
  @Output() closeSelected: EventEmitter<boolean> = new EventEmitter();
  @Output() statusChanged: EventEmitter<SelectionArguments> = new EventEmitter();

  get isSmallView(): boolean {
    return this.settingsService.settings.documentMode.documentToolbarMode === DocumentToolbarMode.Small;
  }

  get isDefaultView(): boolean {
    return this.settingsService.settings.documentMode.documentToolbarMode === DocumentToolbarMode.Default;
  }

  statusHasChanged(args: SelectionArguments) {
    this.statusChanged.emit(args);
  }

  close() {
    this.closeSelected.emit(true);
  }
}
